import { useQuery } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';
import type { SearchParams, Review } from '../types';

export const listingsKey = (params?: SearchParams) =>
  ['marketplace', 'listings', params] as const;

export const listingDetailKey = (slug: string) =>
  ['marketplace', 'listing', slug] as const;

export function useListings(params?: SearchParams) {
  return useQuery({
    queryKey: listingsKey(params),
    queryFn: () => marketplaceService.searchListings(params ?? {}),
  });
}

export function useListing(slug: string) {
  return useQuery({
    queryKey: listingDetailKey(slug),
    queryFn: () => marketplaceService.getListing(slug),
    enabled: !!slug,
  });
}

export const listingReviewsKey = (slug: string) =>
  ['marketplace', 'listing', slug, 'reviews'] as const;

export function useListingReviews(slug: string) {
  return useQuery({
    queryKey: listingReviewsKey(slug),
    queryFn: () => marketplaceService.getListingReviews(slug),
    enabled: !!slug,
  });
}
